import * as types from './mutation-types'

export default {
  [types.SET_SURVEYS] (state, surveys) {
    state.surveys = [...surveys]
  },
  [types.DELETE_SURVEY] (state, survey) {
    const index = state.surveys.findIndex(n => n.id === survey.id)
    state.surveys[index] = survey
  },
  [types.SET_IS_SHOW_SURVEYS_MODAL] (state, status) {
    state.isShowSurveysModal = status
  },
  [types.SET_IS_SHOW_SURVEYS_TO_LOCALSTORAGE] (state) {
    state.isShowSurveysModal = true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/surveys/mutations.js